import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getInitialAdminOfficeCode } from "../../../utils/adminCompany";

export const filterOrgRowsByCompany = (
  rows,
  isAdminUser,
  selectedCompanyCode,
  codeField,
) => {
  if (!isAdminUser || !selectedCompanyCode) {
    return rows || [];
  }

  const prefix = String(selectedCompanyCode);
  return (rows || []).filter((item) =>
    String(item?.[codeField] ?? "").startsWith(prefix),
  );
};

export default function useAdminOrgCompanyFilter() {
  const { code: userOfficeCode, selectedAdminCompanyCode } = useSelector(
    (state) => state.auth,
  );
  const isAdminUser = String(userOfficeCode) === "10";
  const [selectedCompanyCode, setSelectedCompanyCode] = useState(() =>
    getInitialAdminOfficeCode(userOfficeCode, selectedAdminCompanyCode),
  );

  useEffect(() => {
    if (isAdminUser && selectedAdminCompanyCode) {
      setSelectedCompanyCode(String(selectedAdminCompanyCode));
    }
  }, [isAdminUser, selectedAdminCompanyCode]);

  const handleChangeCompany = (company) => {
    setSelectedCompanyCode(company);
  };

  const getCircleApiCompanyCode = () => {
    if (!isAdminUser) {
      return parseInt(String(userOfficeCode).slice(0, 2), 10);
    }
    if (!selectedCompanyCode) {
      return null;
    }
    return parseInt(String(selectedCompanyCode), 10);
  };

  const getCfcApiCompanyCode = () => {
    if (!isAdminUser) {
      return parseInt(String(userOfficeCode).slice(0, 2), 10);
    }
    if (!selectedCompanyCode) {
      return null;
    }
    return parseInt(String(selectedCompanyCode), 10);
  };

  const getHierarchyApiScopeCode = () => {
    if (!isAdminUser) {
      return null;
    }
    return 10;
  };

  return {
    isAdminUser,
    selectedCompanyCode,
    handleChangeCompany,
    getCircleApiCompanyCode,
    getCfcApiCompanyCode,
    getHierarchyApiScopeCode,
    filterOrgRowsByCompany,
  };
}
